import { ESendMessageActionTypes, ISendFirstMessagePayload, ISendMessagePayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Не удалось отправить сообщение на стороне клиента
 */
export const setSendMessageFailed = actionGenerator<ESendMessageActionTypes.SetFailed, ISendMessagePayload>(
  ESendMessageActionTypes.SetFailed,
);

/**
 * Удачная отправка сообщения
 */
export const setSendMessageSuccess = actionGenerator<ESendMessageActionTypes.SetSuccess, ISendMessagePayload>(
  ESendMessageActionTypes.SetSuccess,
);

/**
 * Удачная отправка первого сообщения
 */
export const setSendFirstMessageSuccess = actionGenerator<
  ESendMessageActionTypes.SetFirstMessageSuccess,
  ISendFirstMessagePayload
>(ESendMessageActionTypes.SetFirstMessageSuccess);

/**
 * Ожидание отправки сообщения
 */
export const setSendMessagePending = actionGenerator<ESendMessageActionTypes.SetPending, ISendMessagePayload>(
  ESendMessageActionTypes.SetPending,
);

/**
 * Отмена отправки сообщения
 */
export const setSendMessageAbort = actionGenerator<ESendMessageActionTypes.SetAbort, ISendMessagePayload>(
  ESendMessageActionTypes.SetAbort,
);
